export const notifications = {
  'price': '#FFBC64',
  'voucher': '#FFBC64',
  'free_mode': '#D7FF85',
  'opening_schedule': '#FFBC64',
  'iva_tax': '#FFBC64',
  'cativation_price': '#85CEFF',
  'locker_safe_time': '#85CEFF',
  'custom': '#813B2F'
}